import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";

import UserBasicInfo from "./UserBasicInfo";
import UserMap from "./UserMap";
import UserTimeline from "./UserTimeline";
import CalendarPopup from "./CalendarPopup";

import liveTrackService from "../Services/liveTrackService";
import { formatToIndianDate } from "../../utils/dateFormatter";
import employeeAnalyticsService from "../Services/employeeAnalyticsService";
import CustomHeading from "../../components/common/CustomHeading";
import UserTodayActivity from "./UserTodayActivity";
import UserMonthAnalysis from "./UserMonthAnalysis";
import useScrollToTop from "../../components/hooks/useScrollToTop";

const UserInfoPage = () => {
  const location = useLocation();
  const { employeeId, employeeName, employeeStatus, selectedDate } =
    location.state || {};

  console.log(location.state);

  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];

  const [currentDate, setCurrentDate] = useState(
    selectedDate || formattedToday
  );
  const [showCalendar, setShowCalendar] = useState(false);

  const [isLiveTracking, setIsLiveTracking] = useState(false);

  const [selectedUser, setSelectedUser] = useState(employeeId);

  const [employeeData, setEmployeeData] = useState({});

  const fetchEmployeeInfo = async (employeeId, currentDate) => {
    try {
      const response = await employeeAnalyticsService.employeeInfo({
        userId: employeeId,
        date: currentDate,
      });

      if (response && response.data) {
        setEmployeeData(response.data);
      }
    } catch (error) {
      console.error("Error fetching employee info:", error);
    }
  };

  useEffect(() => {
    fetchEmployeeInfo(employeeId, currentDate);
  }, [selectedUser, currentDate, isLiveTracking]);

  const handleDateSelect = (selectedDate) => {
    // Convert "DD/MM/YYYY" → "YYYY-MM-DD"
    const [day, month, year] = selectedDate.split("/");
    const formatted = `${year}-${month.padStart(2, "0")}-${day.padStart(
      2,
      "0"
    )}`;
    setCurrentDate(formatted); // Update state for API
  };

  const handleDateClick = () => {
    setShowCalendar(true);
  };

  const handleCloseCalendar = () => {
    setShowCalendar(false);
  };



  useScrollToTop();
  return (
    <div className="min-h-screen bg-appGrayBackground">
      <Header />
      <div className="px-6 pt-28 pb-10">
        {/* Header Section */}
        <div className="flex justify-between items-center mb-8">
          <CustomHeading
            title={"User Info"}
            textColor={"primary"}
            isIcon={true}
          />
          <div className="flex items-center gap-4">
            {/* Date Navigation */}
            <div className="flex items-center gap-2 bg-white rounded-lg px-3 py-2 border border-gray-200">
              {/* <button
                onClick={() => handleDateNavigation("prev")}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button> */}
              {/* <button
                onClick={handleDateClick}
                className="text-sm text-gray-600 mx-2 hover:text-blue-600 cursor-pointer transition-colors"
              >
                {formatToIndianDate(currentDate)}
              </button> */}

                         <input
                type="date"
                value={currentDate}
                onChange={(e) => setCurrentDate(e.target.value)}
                className="text-sm text-gray-600 mx-2 hover:text-blue-600 cursor-pointer transition-colors"
                max={formattedToday} // Prevent future dates
              />
              {/* <button
                onClick={() => handleDateNavigation("next")}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button> */}
            </div>

            {/* Present Status */}
          </div>
        </div>

        {/* Main Content */}
        <div className="flex flex-col  gap-6">
          <div className="bg-white flex flex-col gap-4 rounded-xl p-6 shadow-sm border border-gray-100">
            <UserBasicInfo employeeData={employeeData} />

            <UserTodayActivity
              employeeData={employeeData}
              employeeStatus={employeeStatus}
            />
          </div>

          <UserMonthAnalysis employeeId={employeeId} />

          {/* <div className="grid lg:grid-cols-12 gap-6 items-stretch">
         <div className="lg:col-span-8">
         <div className="h-full">
            <UserMap data={trackingData} selectedPoint={selectedPoint} />
            </div>
          </div>

         
          <div className="lg:col-span-4">
            <div className="h-full">
            <UserTimeline     
            data={trackingData}
            userName={employeeName}
            onPointClick={setSelectedPoint}
            />
            </div>
           
          </div>
         </div> */}
        </div>
      </div>

      {/* Calendar Popup */}
      <CalendarPopup
        currentDate={currentDate}
        onDateSelect={handleDateSelect}
        onClose={handleCloseCalendar}
        isOpen={showCalendar}
      />
    </div>
  );
};

export default UserInfoPage;
